import { SnackbarActions, SnackbarSelectors } from '@/store/snackbar';
import { Alert, Snackbar } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
export const SnackbarProvider = () => {
    const dispatch = useDispatch();
    const snackbars = useSelector(SnackbarSelectors.getSnackbars);
    const onClose = (id) => {
        id && dispatch(SnackbarActions.dequeueSnackbarWithId(id));
    };
    return (React.createElement(React.Fragment, null, snackbars.map((snackbarOptions) => {
        const { message = '', severity = 'error', ...rest } = snackbarOptions;
        return (React.createElement(Snackbar, { open: true, key: snackbarOptions.id, ...rest, onClose: () => onClose(snackbarOptions?.id || '') },
            React.createElement(Alert, { severity: severity }, message)));
    })));
};
